import * as React from 'react';

const SvgOfferPound: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2l2.226 1.693L17 3.34l1.081 2.579L20.661 7l-.354 2.774L22 12l-1.693 2.226L20.66 17l-2.579 1.081L17 20.661l-2.774-.354L12 22l-2.226-1.693L7 20.66l-1.081-2.579L3.339 17l.354-2.774L2 12l1.693-2.226L3.34 7l2.579-1.081L7 3.339l2.774.354L12 2zm2.479 3.677l1.265-.161.493 1.176.316.755.755.316 1.176.493-.161 1.265-.103.813.495.651.772 1.015-.772 1.015-.495.651.103.813.161 1.265-1.176.493-.755.316-.316.755-.493 1.176-1.265-.161-.813-.103-.651.495-1.015.772-1.015-.772-.651-.495-.813.103-1.265.161-.493-1.176-.316-.755-.755-.316-1.176-.493.161-1.265.103-.813-.495-.651L4.513 12l.772-1.015.495-.651-.103-.813-.161-1.265 1.176-.493.755-.316.316-.755.493-1.176 1.265.161.813.103.651-.495L12 4.513l1.015.772.651.495.813-.103zm-2.99 8.493c.302-.437.48-.956.488-1.466V12.7c0-.067-.002-.131-.005-.193h2.03V11h-2.394c-.087-.272-.147-.514-.147-.757 0-.57.387-.981.934-.981.383 0 .788.25 1.011.634l.125.216 1.222-1.129-.08-.138A2.753 2.753 0 0012.261 7.5c-1.404.012-2.586 1.069-2.586 2.52 0 .34.066.668.153.98H9.3v1.507h.926c.004.04.005.079.005.119 0 .59-.308 1.314-.826 1.788l-.064.06V15.9h5.329v-1.73h-3.182z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgOfferPound;
